module.exports = __webpack_public_path__ + "static/media/apartment16.9a83e838.jpg";